module.exports = __webpack_public_path__ + "media/images/greencheckmark-1030ec67.svg";